module.exports = __webpack_public_path__ + "media/images/pokerroom/titan/step4-pict01-7c09d5c86651f6c4c1a3624d5c44e003.jpg";